import React, { useState, useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import isNil from 'lodash/isNil';

import announce from '../../../helpers/announce';
import { NumberTextField } from '../TextField';

function getNumberValue(event) {
    const value = event?.target?.value;

    if (value) {
        const numValue = parseInt(value, 10);
        return numValue;
    }

    return null;
}

export default function Minutes({
    minutes: minutesNum,
    onChange,
    isInvalid,
    isRequired,
    isDisabled,
    onBlur,
    increment,
    decrement,
    id,
}) {
    const [value, setValue] = useState(minutesNum?.toString() || '');
    const lastCorrectValue = useRef(value);

    useEffect(() => {
        if (!isNil(minutesNum) && minutesNum.toString() !== value) {
            const newMinutes = minutesNum < 10 ? `0${minutesNum}` : `${minutesNum}`;
            setValue(newMinutes);
            lastCorrectValue.current = newMinutes;
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [minutesNum]);

    const handleChange = (event) => {
        const numValue = getNumberValue(event);
        const eventValue = event.target.value;

        if (eventValue === '') {
            setValue('');
        } else if (eventValue.length === 1 && numValue > 5) {
            event.preventDefault();
            const newValue = `0${eventValue}`;
            setValue(newValue);
            lastCorrectValue.current = newValue;
            announce(`Adjusted to ${newValue} minutes`);
            onChange(numValue);
        } else if (numValue > 59) {
            setValue('00');
            lastCorrectValue.current = '00';
            onChange(0);
        } else {
            setValue(eventValue);
            lastCorrectValue.current = eventValue;
            onChange(numValue);
        }
    };

    const handleBlur = (event) => {
        const numValue = getNumberValue(event);
        const eventValue = event.target.value;

        if (!eventValue && lastCorrectValue.current) {
            setValue(lastCorrectValue.current);
            onChange(parseInt(lastCorrectValue.current, 10));
        } else if (eventValue && isNil(numValue)) {
            setValue('00');
            onChange(0);
        } else if (eventValue.length === 1) {
            setValue(`0${numValue}`);
            onChange(numValue);
        }
        onBlur();
    };

    const handleKeyDown = (event) => {
        const { key } = event;

        if (key === 'ArrowUp') {
            increment();
        }
        if (key === 'ArrowDown') {
            decrement();
        }
    };

    return (
        <NumberTextField
            isLabelVisible={false}
            label="Minutes"
            id={`${id}-minutes-input`}
            value={value}
            onChange={handleChange}
            onBlur={handleBlur}
            maxLength="2"
            isInvalid={isInvalid}
            isRequired={isRequired}
            isDisabled={isDisabled}
            shouldValidate={false}
            onKeyDown={handleKeyDown}
        />
    );
}

Minutes.propTypes = {
    minutes: PropTypes.number,
    onChange: PropTypes.func,
    isInvalid: PropTypes.bool,
    isDisabled: PropTypes.bool,
    isRequired: PropTypes.bool,
    onBlur: PropTypes.func,
    increment: PropTypes.func,
    decrement: PropTypes.func,
};
